import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild } from '@angular/router';

import { PrivilegeService } from '@core/services/privilege.service';
import { UtilsService } from '@core/services/utils.service';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthenticationGuard implements CanActivate, CanActivateChild {

    /**
     * constructor
     * 
     * @param {Router} _router
     * @param {UtilsService} _utilsService
     * @param {PrivilegeService} _privilegeService
     */
    constructor(private _router: Router,
        private _utilsService: UtilsService,
        private _privilegeService: PrivilegeService) { }

    /**
     * canActivate : to check if a user can visit a route.
     * 
     * @param {ActivatedRouteSnapshot} route 
     * @param {RouterStateSnapshot} state 
     * @returns {Observable | Promise | boolean}
     */
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        return this.checkAuthForRouteByRole(state);
    }

    /**
     * canActivateChild : to check if a user can visit a route children.
     * 
     * @param {ActivatedRouteSnapshot} route 
     * @param {RouterStateSnapshot} state 
     * @returns {Observable | Promise | boolean}
     */
    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        return this.canActivate(route, state);
    }

    /**
     * Check Path accessibility
     * 
     * @param {RouterStateSnapshot} state 
     * @returns {Observable<boolean>}
     */
    private checkAuthForRouteByRole(state: RouterStateSnapshot): Observable<boolean> {
        return this._privilegeService.currentBlockPath.pipe(filter(data => data != null), take(1), map((data) => {
            if (!data.has(state.url.substring(1))) return true;
            this._router.navigate(['/miscellaneous/not-authorized']);
            return false;
        }));
    }
}
